import * as user from './user'
import * as role from './role'
import * as administrator from './administrator'
import * as global from './global'
import * as config from './config'
import * as company from './company'
import * as operation from './operation'
import * as common from './common'
import * as setting from './setting'
import * as member from './member'
import * as dashboard from './dashboard'
import * as advance from './advance'
import * as clockIn from './clockIn'

export default {
  user, // 用户相关api
  role, // 角色相关api
  administrator, // 管理员相关api
  global, // 通用模块api
  config, // 全局配置相关api
  company, // 企业管理
  operation, // 运营管理
  common, // 通用
  setting, // 设置
  member, // 用户
  dashboard, // 首页
  advance, //
  clockIn // 打卡
}
